import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";

class ModalReportsEdit extends Component {
    state = {
        modalDisplay: this.props.display
    }
    
    render() {
        return (
            <div align = "center"  style={{display: this.state.modalDisplay}} className = "modal-edit">
                {this.props.reporte}
            </div>
        )        
    }
}

export default ModalReportsEdit;


// WEBPACK FOOTER //
// ./src/components/Reportes/ModalReportsEdit.jsx